// extracted by css-extract-rspack-plugin
export default {"cls1":"LoadingDots-cls1_PY5","cls2":"LoadingDots-cls2_b-N LoadingDots-cls1_PY5"};